/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'search': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" _fill="#1D3861" d="M8.614 2c3.647 0 6.615 2.927 6.615 6.53 0 1.565-.56 3.001-1.49 4.126l4.121 4.122a.516.516 0 01-.728.729l-4.11-4.11a6.639 6.639 0 01-4.407 1.663C4.97 15.06 2 12.134 2 8.53 2 4.929 4.969 2 8.614 2zm0 1.031c-3.079 0-5.583 2.47-5.583 5.5s2.504 5.498 5.584 5.498c3.08 0 5.582-2.468 5.582-5.498 0-3.031-2.503-5.5-5.583-5.5z" fill-rule="evenodd"/>'
  }
})
